// Utils
import { createDeepSelector } from '../../../utils/milanoteReselect/milanoteReselect';
import { toArray } from '../../../../common/utils/immutableHelper';
import { getTableContentColWidthsGU } from '../../../../common/elements/utils/elementPropertyUtils';
import { createSelector } from 'reselect';
import { getCurrentlyEditingEditorId } from '../../selection/currentlyEditingSelector';
import { getTableCellEditorId } from '../bridge/utils/tableEditorSessionUtils';

/**
 * Used to get a memoized version of tableContent.colWidthsGU (in JS object format)
 */
export const getTableContentColWidthsGUSelector = () => {
    return createDeepSelector(
        (state, ownProps) => ownProps.element,
        (element) => {
            return toArray(getTableContentColWidthsGU(element)) || [];
        },
    );
};

export const isCurrentlyEditingTableCell = (elementId) =>
    createSelector(
        getCurrentlyEditingEditorId,
        (currentlyEditingEditorId) => currentlyEditingEditorId === getTableCellEditorId(elementId),
    );
